module.exports = __webpack_public_path__ + "static/media/p10004.d446545b.png";